import React from 'react';

const PlaybookSection = ({ title, icon, heading = false, children, className = '' }) => (
  <section className={`mb-12 mt-10 ${className}`} aria-labelledby={title.replace(/\s+/g, '-').toLowerCase()}>
    <div className="flex items-center mb-6">
      {icon && <span className="mr-3">{icon}</span>}
      {heading ? (
        <h2 className="text-2xl font-bold text-white tracking-tight" id={title.replace(/\s+/g, '-').toLowerCase()}>{title}</h2>
      ) : (
        <div className="text-xl font-semibold text-white tracking-tight">{title}</div>
      )}
    </div>
    <div className="space-y-6">
      {children}
    </div>
  </section>
);

export default PlaybookSection; 